<template>
  <!-- 앱: 앱 전용 상단 네비게이션 -->
  <div v-if="isApp" class="lg:flex flex-1">
    <appNavigator :page="pageName" />
    <EduRegisterPayPage/>
  </div>

  <!-- 웹: 컨퍼런스 네비게이션 -->
  <template v-else>
    <TNavComponent />
    <EduRegisterPayPage/>
  </template>
</template>

<script>
import TNavComponent from "@/components/new/TNavComponent.vue";
import EduRegisterPayPage from "@/pages/EduRegisterPayPage.vue";
import AppNavigator from "@/components/appNavigator.vue";

export default {
  name: "EduRegisterConfirmView",
  components: {AppNavigator, TNavComponent, EduRegisterPayPage},
  data() {
    return {
      pageName: this.$route.name
    }
  },
  computed: {
    isApp() {
      return this.pageName === "eduRegisterConfirmApp";
    },
  },
}
</script>

<style scoped>

</style>
